import * as React from 'react';
import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';

export default function AlertDialog({ open, onClose, templateName, templateId,  handleSync }) {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        {"Sync Template"}
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
            {templateName && (
                <>
                    Are you sure you want to Sync {templateName} Template?
                </>
            )}
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>Cancel</Button>
        <Button onClick={() => handleSync(templateId)} autoFocus>
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
}
